import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import operations from './operations';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';

const options = {
  name: 'p2000Messages',
  baseType: 'P2000_MESSAGES',
  apiEndpoint: 'p2000_messages'
};

const selectors = createMetadataAPISelectors(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
